import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Table } from "reactstrap";
import classNames from "classnames";
import Button from "../../../../../components/Button";
import { useCompanyDateFormat, useCompanyTimeFormat, useCompanyTimeZone } from "../../../../../utils/hooks/company";
import { dateTimeFormat } from "../../../../../utils/helpers/date";
import { renderUserName } from "../../../../../utils/helpers/user";

export const versionStatusColors = { pending: "text-warning", current: "text-success", finished: "text-muted" };

export const useRenderVersionRange = () => {
    const dateFormat = useCompanyDateFormat();
    return (version) => version
        ? `${dateTimeFormat(version.startEffectiveDate, dateFormat)} - ${version.endEffectiveDate ? dateTimeFormat(version.endEffectiveDate, dateFormat) : ""}`
        : "";
};

// Versions of a time off plan: effective from - until, status, saved by / at; Discard on the
// pending one when `onDiscard` is given.
function VersionsTable({ versions, onDiscard, className }) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const timeFormat = useCompanyTimeFormat();
    const timezone = useCompanyTimeZone();
    const renderRange = useRenderVersionRange();

    return (
        <div className="table-responsive">
            <Table size="sm" className={classNames("mb-0 small", className)}>
                <thead>
                    <tr>
                        <th>{t("time-off-plan-version-effective")}</th>
                        <th>{t("status")}</th>
                        <th>{t("time-off-plan-version-saved-by")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {versions.map((version) => (
                        <tr key={version.id} className={version.status === "pending" ? "font-weight-bold" : undefined}>
                            <td className="text-nowrap">{renderRange(version)}</td>
                            <td className={versionStatusColors[version.status]}>{t(version.status)}</td>
                            <td>
                                {version.createdBy?.id ? renderUserName(version.createdBy) : "-"}
                                {version.createdAt && (
                                    <span className="d-block text-muted">
                                        {moment.tz(version.createdAt, timezone || moment.tz.guess()).format(`${dateFormat} ${timeFormat}`)}
                                    </span>
                                )}
                            </td>
                            <td className="text-right align-middle">
                                {version.status === "pending" && onDiscard && (
                                    <Button
                                        type="button"
                                        color="danger"
                                        size="sm"
                                        className="shadow-none py-1"
                                        onClick={() => onDiscard(version)}
                                    >
                                        {t("discard")}
                                    </Button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default VersionsTable;
